// extracted by mini-css-extract-plugin
export default {"root":"MPe_H","autopromo":"IbvDj","geoentitiesAtAdressTitle":"CjYtr"};